import getSimpleDateString from './getSimpleDateString';
export default function dateAIsBeforeB(a, b) {
    return getSimpleDateString(a) < getSimpleDateString(b);
}
